import React from 'react';
import { PageHero } from '../components/PageHero';
import { AISecurityValidation } from '../components/AISecurityValidation';
import { AttackPathExamples } from '../components/AttackPathExamples';
import { Verification } from '../components/Verification';
import { SectionStage } from '../components/SectionStage';
export function AISecurity() {
  return <>
      <PageHero eyebrow="AI Security Validation" title="Secure the AI apps" titleMuted="you build." description="LLM apps, agents, and copilots are creating risk faster than security teams can review. Periscan validates the AI applications you build like adversaries — and proves they're safe to ship." bg="none" data-id="element-1564" />
      <SectionStage fx="matrix-aurora" data-id="element-1565">
        <AISecurityValidation data-id="element-1566" />
      </SectionStage>
      <SectionStage fx="threads" data-id="element-1567">
        <AttackPathExamples data-id="element-1568" />
      </SectionStage>
      <SectionStage fx="ripple" data-id="element-1569">
        <Verification data-id="element-1570" />
      </SectionStage>
    </>;
}